import React from "react"
import TableView, { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { EmptyCard, TableSkeleton } from "../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { linkWithCtrl } from "../../../../helpers/Utils.js"
import { useSelector } from "react-redux"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { useLocation } from "react-router-dom"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { useTranslation } from "react-i18next"
import SVG from "react-inlinesvg"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { LABELING_CONST, isFrozen } from "../../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"

export function Rejected({
  data,
  changePage,
  history,
  general,
  initialFilterTable,
  isFilter,
  status
}) {
  const privileges = loadUserLogin().privilege
  const { General } = useSelector((state) => state)
  const { t } = useTranslation()
  const location = useLocation()

  const columns = [
    {
      dataField: "code",
      text: t("label_farmer_id"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className="text-dark font-weight-bolder mb-1 font-size-lg">
            {stringFormatting(e?.farmer_code)}
          </div>
        )
      },
      sortCaret: sortCaret,
      sort: false,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "name",
      text: t("label_farmer_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmerName
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "account.mitra.name",
      text: t("label_mitra_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitraName
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "address",
      text: t("label_address"),
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      formatExtraData: {
        externalStyle: (e) => <>{stringFormatting(e?.full_address)}</>
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      dataField: "reason",
      text: t("label_rejection_reason"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiReason
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      dataField: "modifiedDate",
      text: t("label_rejected_date"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiRejectDate
      },
      sort: true,
      sortCaret: sortCaret,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      headerStyle: () => {
        return { width: "10%" }
      }
    },

    {
      dataField: "action",
      text: "Action",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      },
      headerStyle: () => {
        return { width: "15%" }
      }
    }
  ]

  function uiRejectDate(e) {
    return (
      <div>
        <div>{e?.reject_date ? timeStampToDate(e?.reject_date, "dd-MM-yyyy") : "-"}</div>
        <div>{e?.reject_date ? timeStampToDate(e?.reject_date, "HH:mm:ss") : "-"}</div>
      </div>
    )
  }
  function uiAction(e) {
    return (
      <div>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FARMER_REGISTERED) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() => history.push(RoutesConstants.FARMER.DETAIL_FARMER("rejected", e?.id))}>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.UPDATE_FARMER) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() => history.push(RoutesConstants.FARMER.EDIT_FARMER_STATUS(status, e.id))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </div>
    )
  }

  function uiReason(e) {
    return <ul>{e?.reject_reason && e.reject_reason.map((item, i) => <li key={i}>{item}</li>)}</ul>
  }

  function uiMitraName(e) {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <a className="text-dark font-weight-bolder font-size-lg">{stringFormatting(e?.mitra_name)}</a>
          {isFrozen(e?.mitra_status) && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.mitra_status === LABELING_CONST.BLACKLISTED && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
        <span className="text-muted font-weight-bold d-block">{stringFormatting(e?.mitra_code)}</span>
      </>
    )
  }

  function uiFarmerName(e) {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <a className="text-dark font-weight-bolder font-size-lg">{stringFormatting(e?.farmer_name)}</a>
          {isFrozen(e?.farmer_status) && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.farmer_status === LABELING_CONST.BLACKLISTED && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
        {privileges.indexOf(PRIVILEGE_ENUM.FARMER_PHONE_NUMBER) > -1 && (
          <span className="text-muted font-weight-bold d-block">{stringFormatting(e?.farmer_phone)}</span>
        )}
      </>
    )
  }

  return (
    <>
      <Card className="card-shadowless">
        <CardBody>
          {General?.loading ? (
            <TableSkeleton column={5} row={10} />
          ) : data?.pageData?.length == 0 ? (
            <EmptyCard
              subtitle={isFilter ? t("messages_response_empty_search_subtitle") : ""}
              image={
                isFilter
                  ? ILLUSTRATION_CONSTANTS.NOT_FOUND_FARMER
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_FARMER
              }
              body={
                isFilter
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_empty_state", { name: "petani" })
              }
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={data?.pageData ?? []}
            currentPage={data?.page?.currentPage ?? 1}
            currentElement={data?.page?.currentElement ?? 10}
            totalCount={data?.page?.totalCount ?? 0}
            loadingGetData={general?.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_MITRA_REGISTERED) > -1) {
                  if (e.target.cellIndex < 4) {
                    const url = RoutesConstants.FARMER.DETAIL_FARMER("rejected", row?.id)
                    if (e.ctrlKey) {
                      linkWithCtrl(url)
                    } else {
                      history.push(url)
                    }
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}
